import React from 'react';
import MeAgendaContainer from '../../../Components/Dashboards/Me/MeAgendaContainer';

export default function MeAgenda() {
    return (
        <div className='page-body'>
            <MeAgendaContainer />
        </div>
    );
}
